import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomDialog from 'src/app/components/CustomDialog';
import { STATUS_API } from 'src/app/constant/config';
import { updateLicensePlate } from 'src/features/deviceSlice';
import * as Yup from 'yup';

function ChangeLicensePlate({ open, onClose, device, onSuccess }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const statusUpdate = useSelector(state => state.deviceSlice.statusUpdate);

  const handleSubmit = async values => {
    await dispatch(
      updateLicensePlate({
        id: device?.id,
        data: {
          license_plate: values.vehicle_license_plate?.trim() || '',
        }
      })
    );

    onSuccess?.();
    onClose();
  };

  return (
    <CustomDialog title="Đổi biển số phương tiện" open={open} onClose={onClose}>
      <Formik
        initialValues={{
          device_code: device?.serial || '',
          vehicle_license_plate: device?.vehicle?.license_plate || ''
        }}
        enableReinitialize
        validationSchema={Yup.object().shape({
          vehicle_license_plate: Yup.string()
            .trim()
            .max(20, 'Biển số tối đa 20 ký tự')
            .required('Biển số không được để trống')
        })}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <InputLabel>Serial thiết bị</InputLabel>
                <TextField
                  fullWidth
                  disabled
                  margin="normal"
                  className="input-no-fieldset"
                  name="device_code"
                  size="small"
                  value={values.device_code}
                  variant="outlined"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <InputLabel>Biển số mới</InputLabel>
                <TextField
                  fullWidth
                  margin="normal"
                  className="input-no-fieldset"
                  name="vehicle_license_plate"
                  size="small"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.vehicle_license_plate}
                  error={Boolean(
                    touched.vehicle_license_plate &&
                      errors.vehicle_license_plate
                  )}
                  helperText={
                    touched.vehicle_license_plate &&
                    errors.vehicle_license_plate
                  }
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Box my={3}>
              <div className={classes.groupButtonSubmit}>
                <div className={classes.wrapper}>
                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 90 }),
                      marginRight: '10px'
                    }}
                    onClick={onClose}
                    className="btn-main btn-plain mx-3"
                    color="primary"
                    size="large"
                    variant="contained"
                  >
                    Thoát
                  </Button>

                  <Button
                    style={{
                      ...(isMobile && { maxWidth: 120 }),
                      marginRight: '10px'
                    }}
                    className="btn-main mx-3"
                    color="primary"
                    size="large"
                    type="submit"
                    variant="contained"
                    disabled={statusUpdate === STATUS_API.PENDING}
                  >
                    Lưu lại
                  </Button>

                  {statusUpdate === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </div>
            </Box>
          </form>
        )}
      </Formik>
    </CustomDialog>
  );
}

const useStyles = makeStyles(() => ({
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px'
  },
  wrapper: {
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}));

export default React.memo(ChangeLicensePlate);
